import { Outlet, useLocation } from "react-router";

import { LocaleSwitch } from "@/client/components/locale-switch";

//const authRoutes = [{ path: "client/auth/login" }, { path: "client/auth/register" }];

export const AuthAdmLayout = () => {
  const location = useLocation();
  return (
    // eslint-disable-next-line tailwindcss/enforces-shorthand -- size-screen not implemented yet
    <div className="flex h-screen w-screen">
      <div className="relative flex w-full flex-col justify-center gap-y-8 px-12 sm:mx-auto sm:basis-[420px] sm:px-0 lg:basis-[480px] lg:px-12">
        <div className="flex items-center justify-between">
          <div className="right-0 space-x-2 text-right lg:absolute lg:p-12 lg:text-center">
            <LocaleSwitch />
          </div>
        </div>

        <Outlet />
      </div>
    </div>
  );
};
